import { QuestionnaireTemplateDetailProps } from '@/types/questionnaire';
import { AdminBreadcrumb } from '../../components/AdminBreadcrumb';

export function SectionBreadcrumb({
  template,
}: {
  template: QuestionnaireTemplateDetailProps;
}) {
  return (
    <AdminBreadcrumb
      items={[
        { label: 'Applications', href: '/admin/questionnaire_templates' },
        { label: template.title, isCurrentPage: true },
      ]}
    />
  );
}
